function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MongoliaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2538",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      rx: "-1",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2538)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 3H16.5V21H7.5V3Z",
      fill: "#4C67E8"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.5 3H24V21H16.5V3Z",
      fill: "#C51918"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H9V21H0V3Z",
      fill: "#C51918"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.5104 8.16316C3.75039 8.16316 3.85015 7.42266 3.85015 7.42266L4.2105 6.64446V6.95793V7.42266C4.2105 7.52275 4.34708 7.32256 4.34708 7.08158C4.34708 6.8406 4.5104 6.47974 4.5104 6.47974C4.5104 6.47974 4.51696 6.35908 4.52148 6.23994C4.54762 6.30124 4.60002 6.35431 4.67958 6.43489C4.69345 6.44894 4.70815 6.46383 4.72368 6.47974C4.81757 6.57596 4.80491 6.83085 4.79395 7.05139C4.78402 7.25111 4.7755 7.42266 4.84879 7.42266C5.00302 7.42266 4.99156 6.73358 4.99156 6.73358L5.2504 7.42266C5.2504 7.42266 5.27041 8.16316 4.5104 8.16316ZM4.5104 6.0484C4.52974 5.93534 4.5273 6.08638 4.52148 6.23994C4.49965 6.18875 4.49613 6.13184 4.5104 6.0484ZM5.65384 9.5128C5.65384 10.1148 5.15016 10.6029 4.52884 10.6029C3.90752 10.6029 3.40384 10.1148 3.40384 9.5128C3.40384 8.91078 3.90752 8.42275 4.52884 8.42275C5.15016 8.42275 5.65384 8.91078 5.65384 9.5128ZM2.82692 11.5532H1.5V17.9817H2.82692V11.5532ZM7.5 11.5532H6.17308V17.9817H7.5V11.5532ZM3.17308 11.6091L4.46662 12.41L5.92453 11.6091H3.17308ZM4.46662 18L3.17308 17.1991H5.92453L4.46662 18ZM3.17308 12.6712H5.88462V13.1743H3.17308V12.6712ZM5.88462 16.4165H3.17308V16.9196H5.88462V16.4165ZM4.55769 16.137C5.3224 16.137 5.94231 15.5364 5.94231 14.7954C5.94231 14.0545 5.3224 13.4538 4.55769 13.4538C3.79299 13.4538 3.17308 14.0545 3.17308 14.7954C3.17308 15.5364 3.79299 16.137 4.55769 16.137ZM3.0024 9.91211C3.0024 9.91211 3.04902 11.3126 4.4294 11.3126C5.80978 11.3126 6.03258 9.91211 6.03258 9.91211C6.03258 9.91211 5.49828 10.77 4.51749 10.77C3.5367 10.77 3.0024 9.91211 3.0024 9.91211Z",
      fill: "#F8D000"
    })]
  })]
}));
//# sourceMappingURL=Mongolia.js.map